import {
    Box,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';

export const DataTableSkeleton = () => {
    return (
        <Box padding={3}>
            {/* Header and Filter Bar */}
            <Box display="flex" alignItems="center" mb={2}>
                <Typography variant="h5">
                    <Skeleton width={100} />
                </Typography>
                <Skeleton
                    variant="rounded"
                    width={100}
                    height={36}
                    style={{ marginLeft: 16 }}
                />
            </Box>

            {/* Table Skeleton */}
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Skeleton width={20} />
                            </TableCell>
                            <TableCell>
                                <Skeleton width={100} />
                            </TableCell>
                            <TableCell>
                                <Skeleton width={100} />
                            </TableCell>
                            <TableCell>
                                <Skeleton width={100} />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {[...Array(8)].map((_, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <Skeleton
                                        variant="circular"
                                        width={40}
                                        height={40}
                                    />
                                </TableCell>
                                <TableCell>
                                    <Skeleton width={120} />
                                    <Skeleton width={80} />
                                </TableCell>
                                <TableCell>
                                    <Skeleton width={150} />
                                </TableCell>
                                <TableCell>
                                    <Skeleton width={80} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Floating Button */}
            <Box position="fixed" bottom={24} right={24}>
                <Skeleton variant="circular" width={56} height={56} />
            </Box>
        </Box>
    );
};
